<template>
	<div class="plugStyle">
		<div class="leftdiv">
			<div v-loading="isDisabled">
				<el-row style="margin-bottom: 25px" type="flex" justify="space-between">
					<el-col :span="9">
						<div class="clearance">插件展示位置：</div>
						<el-select v-model="weizhi" @change="changeinfo" class="select-box">
							<el-option
								v-for="item in positionArr"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-col>
					<el-col :span="9" v-if="!isPlugIn">
						<div class="clearance">插件颜色：</div>
						<el-color-picker v-model="yanse" @change="changeinfo"></el-color-picker>
					</el-col>
					<el-col :span="9" v-else>
						<div class="clearance">距离底部：</div>
						<el-input-number
							v-model="juli"
							controls-position="right"
							@change="changeinfo"
							:min="0"
						></el-input-number>
					</el-col>
					<!-- <el-col :span="9">
                        <div class="clearance">访客模式</div>
                        <el-select v-model="zhuangtai" @change="changeinfo">
                            <el-option v-for="item in stateArr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col> -->
				</el-row>
				<!-- <el-row style="margin-bottom:25px" type="flex" justify="space-between">
                    <el-col :span="9">
                        <div class="clearance">插件颜色</div>
                        <el-color-picker v-model="yanse" @change="changeinfo"></el-color-picker>
                    </el-col>
                    <el-col :span="9">
                        <div class="clearance">聊天插件显示方式</div>
                        <el-select v-model="mode" @change="changeinfo">
                            <el-option v-for="item in modeArr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row style="margin-bottom:25px" type="flex" justify="space-between">
                    <el-col :span="24">
                        <div class="clearance">问候语</div>
                        <el-input type="text" v-model="greet" @change="changeinfo" @input="computedByteLen(greet)" :disabled="isDisabled">
                        </el-input>
                    </el-col>
                </el-row> -->
			</div>

			<!-- <el-row style="margin-bottom:10px">
                <el-col :span="24">
                    <radioBox title="按钮外观" subtitle="设置聊天按钮的外观" :pointIcon="pointIcon" :pointLabel="pointLabel"
                        :radioArr="buttonRadio" @changeContent="changeWords">
                    </radioBox>
                </el-col>
            </el-row>
            <el-row v-if="showWords" style="margin-bottom:25px" type="flex" justify="space-between">
                <el-col :span="24">
                    <div class="clearance">文字内容</div>
                    <el-select v-model="words" @change="changeinfo" style="width:100%">
                        <el-option v-for="item in contentArr" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row v-if="showIcon">
                <el-col :span="24">
                    <radioBox title="图标样式" subtitle="选择与品牌形象契合的预设图标" :pointIcon="pointIcon" :pointLabel="pointLabel"
                        :radioArr="pictureRadio" @changebuttonRadio="changeButton"></radioBox>
                </el-col>
            </el-row> -->
		</div>
		<!-- <div class="rightdiv">
            <table class="tabar" cellspacing="0" cellpadding="0" width="250px" height="36px">
                <tr>
                    <td>
                        <div class="method" :class="{ methodActive: preview === 'computer' }" @click="selectComputer">电脑预览
                        </div>
                    </td>
                    <td>
                        <div class="method" :class="{ methodActive: preview === 'iphone' }" @click="selectPhone">手机预览
                        </div>
                    </td>
                </tr>
            </table>
            <div class="image" v-if="this.preview === 'computer'">
                <div v-if="this.mode == 0">
                    <div class="circle">
                        <img :src="thumb ? thumb : require('@/assets/staffPhoto1.png')" class="thumb" />
                    </div>
                    <span class="mess-x">
                        {{ name ? name : '-' }}
                    </span>
                    <span class="mess-l">
                        {{ greet }}
                    </span>
                    <img class="pic"
                        :src="this.zhuangtai ? require('@/assets/computer.png') : require('@/assets/noMode.png')" />
                </div>
                <div style="height:633px" v-if="this.mode !== 0"></div>
                <div class="onlymess" v-if="this.mode == 2">
                    <div class="messz" :class="{ r: this.weizhi == 2 }">{{ greet }}</div>
                </div>
                <img class="icon" :class="{ iconActive: this.weizhi == 2 }" :src="iconUrl" />
            </div>
            <div v-if="this.preview == 'iphone'" class="phone">
                <div v-if="this.mode == 0">
                    <div class="phonecircle">
                        <img :src="thumb ? thumb : require('@/assets/staffPhoto1.png')" class="phonethumb" />
                    </div>
                    <span class="phonemess-x">
                        {{ name ? name : '-' }}
                    </span>
                    <span class="phonemess-l">
                        {{ greet }}
                    </span>
                    <img class="phonepic"
                        :src="this.zhuangtai ? require('@/assets/computer.png') : require('@/assets/noMode.png')" />
                </div>
                <div style="height:638px" v-if="this.mode !== 0"></div>
                <div class="phoneonlymess" v-if="this.mode == 2">
                    <div class="phonemessz" :class="{ phoner: this.weizhi == 2 }">{{ greet }}</div>
                </div>
                <img class="phoneicon" :class="{ phoneiconActive: this.weizhi == 2 }" :src="iconUrl" />
            </div>
        </div> -->
	</div>
</template>
<script>
import radioBox from '@/backend/pages/socialMedia/radioBox.vue';
export default {
	name: 'plugStyle',
	components: {
		radioBox,
	},
	props: [
		'position',
		'color',
		'bottomDistance',
		'state',
		'DialogDisplay',
		'login',
		'pointLabel',
		'pointIcon',
		'thumb',
		'name',
		'isPlugIn',
	],
	data() {
		return {
			preview: 'computer',
			iconUrl: '',
			weizhi: '',
			yanse: '',
			juli: 10,
			zhuangtai: '',
			mode: '',
			greet: '',
			words: '',
			picIcon: '',
			positionArr: [
				{ value: 1, label: '左下' },
				{ value: 2, label: '右下' },
			],
			stateArr: [
				{ value: 0, label: '关闭' },
				{ value: 1, label: '开启' },
			],
			modeArr: [
				{ value: 0, label: '显示完整聊天插件' },
				{ value: 1, label: '只显示图标' },
				{ value: 2, label: '显示图标与问候语' },
			],
			buttonRadio: [
				{ url: require('@/assets/icon_yulan1.png'), index: 0, content: '只显示图标' },
				{ url: require('@/assets/icon_tubiaowenzi.png'), index: 1, content: '图标和文字' },
				{ url: require('@/assets/icon_wenzi.png'), index: 2, content: '只显示文字' },
			],
			pictureRadio: [
				{ url: require('@/assets/icon_yangshiyi.png'), index: 1 },
				{ url: require('@/assets/icon_yangshier.png'), index: 2 },
				{ url: require('@/assets/icon_fangshisan.png'), index: 3 },
			],
			contentArr: [
				{ value: 1, label: 'Chat' },
				{ value: 2, label: 'Ask Us' },
				{ value: 3, label: 'Help' },
			],
			showIcon: '',
			showWords: '',
			isDisabled: false,
		};
	},
	methods: {
		computedByteLen(txt) {
			let temp = 0;
			for (let i = 0; i < txt.length; i++) {
				if (/[^\x00-\xff]/.test(txt[i])) {
					temp += 2;
				} else {
					temp++;
				}
				if (temp > 80) {
					txt = txt.substr(0, i);
				}
			}
			this.greet = txt;
		},
		changeinfo() {
			this.isDisabled = true;
			let { weizhi, zhuangtai, yanse, juli, mode, greet, words, picIcon } = this;
			this.$emit(
				'changebasic',
				{ weizhi, zhuangtai, yanse, juli, mode, greet, words, picIcon },
				this.closeDisabled
			);
			this.changeIconurl();
		},
		closeDisabled() {
			this.isDisabled = false;
		},
		changeEmit(reset) {
			let { weizhi, zhuangtai, yanse, juli, mode, greet, words, picIcon } = this;
			this.$emit(
				'changebasic',
				{ weizhi, zhuangtai, yanse, juli, mode, greet, words, picIcon },
				reset
			);
			this.changeIconurl();
		},
		changeButton(index, reset) {
			if (index == 1) {
				this.buttonRadio = [
					{ url: require('@/assets/icon_yulan1.png'), index: 0, content: '只显示图标' },
					{ url: require('@/assets/icon_tubiaowenzi.png'), index: 1, content: '图标和文字' },
					{ url: require('@/assets/icon_wenzi.png'), index: 2, content: '只显示文字' },
				];
			} else if (index == 2) {
				this.buttonRadio = [
					{ url: require('@/assets/icon_yulan2.png'), index: 0, content: '只显示图标' },
					{ url: require('@/assets/icon_tubiaowenzi01.png'), index: 1, content: '图标和文字' },
					{ url: require('@/assets/icon_wenzi.png'), index: 2, content: '只显示文字' },
				];
			} else if (index == 3) {
				this.buttonRadio = [
					{ url: require('@/assets/icon_yangshi3.png'), index: 0, content: '只显示图标' },
					{ url: require('@/assets/icon_tubiaowenzi02.png'), index: 1, content: '图标和文字' },
					{ url: require('@/assets/icon_wenzi.png'), index: 2, content: '只显示文字' },
				];
			}
			this.picIcon = index;
			this.changeEmit(reset);
		},
		changeWords(index, reset) {
			if (index == 0) {
				this.picIcon = this.picIcon ? this.picIcon : 1;
				this.showWords = false;
				this.showIcon = true;
				this.words = 0;
			} else if (index == 1) {
				this.words = this.words ? this.words : 2;
				this.picIcon = this.picIcon ? this.picIcon : 1;
				this.showWords = true;
				this.showIcon = true;
			} else if (index == 2) {
				this.words = this.words ? this.words : 2;
				this.showIcon = false;
				this.showWords = true;
				this.picIcon = 0;
			}
			this.changeEmit(reset);
		},
		changeIconurl() {
			if (this.words == 0) {
				if (this.picIcon == 0 || this.picIcon == 1) {
					this.iconUrl = require('@/assets/icon_sandian.png');
				} else if (this.picIcon == 2) {
					this.iconUrl = require('@/assets/icon_tuoyuan.png');
				} else if (this.picIcon == 3) {
					this.iconUrl = require('@/assets/icon_fangkuai.png');
				}
			} else if (this.words == 1) {
				if (this.picIcon == 0) {
					this.iconUrl = require('@/assets/icon_liaotian.png');
				} else if (this.picIcon == 1) {
					this.iconUrl = require('@/assets/icon_waiguanyi.png');
				} else if (this.picIcon == 2) {
					this.iconUrl = require('@/assets/icon_waiguan2.png');
				} else if (this.picIcon == 3) {
					this.iconUrl = require('@/assets/icon_waiguan3.png');
				}
			} else if (this.words == 2) {
				if (this.picIcon == 0) {
					this.iconUrl = require('@/assets/icon_tiwen.png');
				} else if (this.picIcon == 1) {
					this.iconUrl = require('@/assets/icon_tiwenyi.png');
				} else if (this.picIcon == 2) {
					this.iconUrl = require('@/assets/icon_tiwen2.png');
				} else if (this.picIcon == 3) {
					this.iconUrl = require('@/assets/icon_tiwen3.png');
				}
			} else if (this.words == 3) {
				if (this.picIcon == 0) {
					this.iconUrl = require('@/assets/icon_help.png');
				} else if (this.picIcon == 1) {
					this.iconUrl = require('@/assets/icon_helpyi.png');
				} else if (this.picIcon == 2) {
					this.iconUrl = require('@/assets/icon_help2.png');
				} else if (this.picIcon == 3) {
					this.iconUrl = require('@/assets/icon_help3.png');
				}
			}
		},
		selectComputer() {
			this.preview = 'computer';
		},
		selectPhone() {
			this.preview = 'iphone';
		},
	},
	created() {
		setTimeout(() => {
			if (this.pointIcon !== 0 && this.pointLabel === 0) {
				this.showIcon = true;
				this.showWords = false;
			} else if (this.pointIcon === 0 && this.pointLabel !== 0) {
				this.showIcon = false;
				this.showWords = true;
			} else {
				this.picIcon = this.picIcon ? this.picIcon : 1;
				this.words = this.words ? this.words : 2;
				this.showIcon = true;
				this.showWords = true;
			}
			this.changeIconurl();
		}, 500);
	},
	watch: {
		position: {
			handler(val) {
				return (this.weizhi = val);
			},
			immediate: true,
		},
		state: {
			handler(val) {
				return (this.zhuangtai = val);
			},
			immediate: true,
		},
		color: {
			handler(val) {
				return (this.yanse = val);
			},
			immediate: true,
		},
		bottomDistance: {
			handler(val) {
				return (this.juli = val);
			},
			immediate: true,
		},
		DialogDisplay: {
			handler(val) {
				return (this.mode = val);
			},
			immediate: true,
		},
		pointLabel: {
			handler(val) {
				return (this.words = val);
			},
			immediate: true,
		},
		pointIcon: {
			handler(val) {
				return (this.picIcon = val);
			},
			immediate: true,
		},
		login: {
			handler(val) {
				return (this.greet = val);
			},
			immediate: true,
		},
		isPlugIn: {
			handler(val) {
				if (val)
					this.positionArr = [
						{ value: 1, label: '左边' },
						{ value: 2, label: '右边' },
					];
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.plugStyle {
	width: 100%;
	height: 140px;

	.leftdiv {
		padding: 20px 20px;
		width: 49%;
		height: 100%;
		float: left;
		// border-right: 1px solid #E8E8E8;

		.clearance {
			margin: 10px 0px;
		}
		.select-box {
			width: 100%;
		}
	}

	.rightdiv {
		width: 50%;
		float: right;
		position: relative;
		.tabar {
			position: relative;
			width: 340px;
			margin-left: -170px;
			left: 50%;
			margin-top: 25px;
			.method {
				text-align: center;
				height: 36px;
				line-height: 36px;
				font-size: 14px;
				color: #333333;
				border: 1px solid #dfe3e9;
				border-radius: 4px 4px 4px 4px;
			}

			.methodActive {
				border: 1px solid #3da1ff;
				color: #3da1ff;
			}
		}

		.image {
			width: 548px;
			position: relative;
			left: 50%;
			margin-left: -274px;

			.circle {
				position: absolute;
				margin-left: -150px;
				top: 100px;
				left: 50%;
				width: 70px;
				height: 70px;
			}

			.thumb {
				width: 60px;
				height: 60px;
				border-radius: 50%;
			}

			.mess-x {
				width: 350px;
				height: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				margin: -175px;
				margin-top: 180px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap; //溢出不换行
				font-size: 18px;
				font-weight: 700;
				color: rgb(20, 20, 20);
			}

			.mess-l {
				width: 260px;
				height: 100%;
				position: absolute;
				left: 50%;
				margin: -130px;
				margin-top: 248px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box; //作为弹性伸缩盒子模型显示。
				-webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
				-webkit-line-clamp: 2; //显示的行
				font-size: 16px;
				font-weight: 500;
				color: rgb(20, 20, 20);
			}

			.pic {
				width: 548px;
				height: 590px;
			}

			.icon {
				margin: -20px 80px;
			}

			.iconActive {
				margin: -20px 410px;
			}

			.onlymess {
				.messz {
					padding: 5px;
					width: 280px;
					border: 1px solid #dfe3e9;
					border-radius: 25px;
					margin: 40px 80px;
					margin-top: -70px;
				}

				.r {
					float: right;
				}
			}
		}

		.phone {
			margin: 15px auto;
			width: 370px;
			height: 740px;
			line-height: 16px;
			background-image: url(https://img.iglobalwin.com/image/mobile.png);
			background-size: 100%;
			background-repeat: no-repeat;

			.phonecircle {
				position: absolute;
				margin-left: -150px;
				top: 75px;
				left: 50%;
			}

			.phonethumb {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				margin: 285px 45px;
			}

			.phonemess-x {
				width: 350px;
				height: 100%;
				text-align: center;
				position: absolute;
				left: 50%;
				margin: -175px;
				margin-top: 330px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap; //溢出不换行
				font-size: 18px;
				font-weight: 700;
				color: rgb(20, 20, 20);
			}

			.phonemess-l {
				width: 260px;
				height: 100%;
				position: absolute;
				left: 50%;
				margin: -130px;
				margin-top: 370px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box; //作为弹性伸缩盒子模型显示。
				-webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
				-webkit-line-clamp: 2; //显示的行
				font-size: 16px;
			}

			.phonepic {
				margin-top: 210px;
				width: 370px;
				border-radius: 45px;
			}

			.phoneicon {
				width: 60px;
				height: 60p;
				margin: 0 50px;
			}

			.phoneiconActive {
				margin: 0 0 40px 250px;
			}

			.phoneonlymess {
				.phonemessz {
					padding: 5px;
					width: 200px;
					border: 1px solid #dfe3e9;
					border-radius: 25px;
					margin: 20px 50px;
					margin-top: -80px;
				}

				.phoner {
					float: right;
				}
			}
		}
	}
}
</style>
<style lang="scss">
.el-color-picker__trigger {
	width: 205px !important;
}

.el-color-dropdown__link-btn {
	display: none !important;
}
</style>
